const setLeadingNumbers = (num = 0, length = 2) => {
  let result = '';

  for (let i = 0; i < length; i += 1) {
    result += 0;
  }

  result += `${num}`;
  result = result.slice(-length);

  return result;
};

/*  */
export { setLeadingNumbers };
